define.alias("shared/utils/formatters/pin-from-dynamo", "settings/utils/formatters/pin-from-dynamo");